import { render, staticRenderFns } from "./file-grid.vue?vue&type=template&id=1af93880&"
import script from "./file-grid.vue?vue&type=script&lang=ts&"
export * from "./file-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports